module.exports = __webpack_public_path__ + "2e7df6f062a1ceb761644d65842c7b8d.png";